import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cart") || "[]"); } catch { return []; }
  });
  useEffect(() => { localStorage.setItem("cart", JSON.stringify(items)); }, [items]);

  const addItem = (product, quantity = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.id);
      if (found) return prev.map((i) => i.product_id === product.id ? { ...i, quantity: i.quantity + quantity } : i);
      return [...prev, { product_id: product.id, name: product.name, price: product.price,
        image_url: product.image_url, slug: product.slug, quantity }];
    });
    toast.success(`${product.name} aggiunto al carrello`);
  };
  const updateQuantity = (id, q) => { if (q < 1) return removeItem(id); setItems((p) => p.map((i) => i.product_id === id ? { ...i, quantity: q } : i)); };
  const removeItem = (id) => setItems((p) => p.filter((i) => i.product_id !== id));
  const clearCart = () => setItems([]);
  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return <CartContext.Provider value={{ items, addItem, updateQuantity, removeItem, clearCart, count, subtotal }}>{children}</CartContext.Provider>;
}
